import { Theme } from '@material-ui/core/styles';
import { TooltipClassKey } from '@material-ui/core/Tooltip';
import tokens from '../tokens';

const MuiTooltip = (theme: Theme): Partial<Record<TooltipClassKey, unknown>> => ({
    tooltip: {
        borderRadius: tokens.radii.semiRounded,
        backgroundColor: theme.palette.grey[600],
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(16),
        padding: theme.spacing(1, 2),
    },
    arrow: {
        color: theme.palette.grey[600],
    },
});

export default MuiTooltip;
